// src/form/form-context.ts
import { createContext } from "react";
var FormContext = createContext(void 0);

export {
  FormContext
};
